var _circle, _circle2, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49.646,
    cy: 49.646,
    r: 49.646,
    fill: "#354E6C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.646,
    cy: 49.646,
    r: 49.146,
    stroke: "url(#paint0_linear_542_76)",
    strokeOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.8372 48.8176L40.8352 31.1598C40.485 30.9537 40.0858 30.843 39.6783 30.839C39.2708 30.835 38.8694 30.9378 38.5152 31.1369C38.1609 31.3361 37.8663 31.6245 37.6613 31.9728C37.4564 32.3211 37.3484 32.7169 37.3484 33.1199V67.7291C37.3489 68.1285 37.4553 68.5207 37.6571 68.8667C37.8588 69.2127 38.1488 69.5002 38.4982 69.7007C38.8475 69.9012 39.2439 70.0075 39.6478 70.0091C40.0517 70.0107 40.4489 69.9075 40.7998 69.7097L70.8016 52.7585C71.1517 52.5607 71.4433 52.2756 71.6472 51.9316C71.8511 51.5877 71.9603 51.1969 71.9639 50.7982C71.9674 50.3995 71.8653 50.0069 71.6675 49.6594C71.4698 49.312 71.1834 49.0218 70.8369 48.8179L70.8372 48.8176ZM40.4243 66.419V34.4573L68.1308 50.7643L40.4243 66.419Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_542_76",
    x1: 49.646,
    y1: 0,
    x2: 49.646,
    y2: 99.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.da40955397c453f321e0a77f3d2c080c.svg";
export { ForwardRef as ReactComponent };